/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Subject_Option_ProjectInputs */

const en_form_subject_option_project = /** @type {(inputs: Form_Subject_Option_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project inquiry`)
};

const ar_form_subject_option_project = /** @type {(inputs: Form_Subject_Option_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استفسار عن مشروع`)
};

const bn_form_subject_option_project = /** @type {(inputs: Form_Subject_Option_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রকল্প অনুসন্ধান`)
};

const de_form_subject_option_project = /** @type {(inputs: Form_Subject_Option_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektanfrage`)
};

const es_form_subject_option_project = /** @type {(inputs: Form_Subject_Option_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consulta de proyecto`)
};

const fr_form_subject_option_project = /** @type {(inputs: Form_Subject_Option_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demande de projet`)
};

const pt_form_subject_option_project = /** @type {(inputs: Form_Subject_Option_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consulta de projeto`)
};

const zh_form_subject_option_project = /** @type {(inputs: Form_Subject_Option_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目咨询`)
};

const tr_form_subject_option_project = /** @type {(inputs: Form_Subject_Option_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proje talebi`)
};

const ru_form_subject_option_project = /** @type {(inputs: Form_Subject_Option_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запрос проекта`)
};

const pl_form_subject_option_project = /** @type {(inputs: Form_Subject_Option_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapytanie o projekt`)
};

/**
* | output |
* | --- |
* | "Project inquiry" |
*
* @param {Form_Subject_Option_ProjectInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const form_subject_option_project = /** @type {((inputs?: Form_Subject_Option_ProjectInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Subject_Option_ProjectInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_form_subject_option_project(inputs)
	if (locale === "bn") return bn_form_subject_option_project(inputs)
	if (locale === "de") return de_form_subject_option_project(inputs)
	if (locale === "es") return es_form_subject_option_project(inputs)
	if (locale === "fr") return fr_form_subject_option_project(inputs)
	if (locale === "pt") return pt_form_subject_option_project(inputs)
	if (locale === "zh") return zh_form_subject_option_project(inputs)
	if (locale === "tr") return tr_form_subject_option_project(inputs)
	if (locale === "ru") return ru_form_subject_option_project(inputs)
	if (locale === "pl") return pl_form_subject_option_project(inputs)
	return en_form_subject_option_project(inputs)
});